
    export default {
        methods: {
            state(validation) {
                if(!validation) {
                  console.error('Missing validation target')
                  return;
                }
                if (!validation.$dirty) {
                  return null;
                }
                return !validation.$error;
              },
        }
    }


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/Validation.js